import { classNames } from 'lib/utils/classnames'
import React, { FunctionComponent } from 'react'

interface IBadgeProps {
  className?: string
}

const Badge: FunctionComponent<IBadgeProps> = ({ children, className = '' }): JSX.Element => {
  return (
    <span
      className={classNames(
        'bg-primary-100 text-primary-800 text-sm font-medium px-2.5 py-0.5 rounded-full',
        className
      )}
    >
      {children}
    </span>
  )
}

export default Badge
